import React from 'react';
import { Box, Skeleton, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

function MemoryHeaderSkeleton() {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          mx: 2,
        }}
      >
        <Skeleton
          variant='rectangular'
          width={60}
          height={60}
          sx={{ borderRadius: '10px' }}
        />
      </Box>
      <Box>
        <Box display='flex' alignItems='center' gap={1}>
          <Skeleton variant='text' width={200} height={28} />
          <Tooltip title='' placement='top' arrow enterTouchDelay={0}>
            <Skeleton variant='circular' width={20} height={20}>
              <InfoOutlinedIcon
                fontSize='small'
                sx={{ color: 'var(--color-label)' }}
              />
            </Skeleton>
          </Tooltip>
        </Box>
        <Skeleton variant='text' width={100} height={24} />
      </Box>
    </>
  );
}

export default MemoryHeaderSkeleton;
